import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '@shared';
import { IColorFan, IPaginationParams } from '@interfaces';

@Injectable({
  providedIn: 'root',
})
export class FansService {
  constructor(private http: HttpClient) {}

  getFans(filterData: any): Observable<ApiResponse> {
    let params = new HttpParams();
    Object.keys(filterData).forEach((key) => {
      params = params.set(key, filterData[key]);
    });
    return this.http.get<ApiResponse>(`v1/admin/color-fans`, { params });
  }

  createColorFans(fanData: IColorFan): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`v1/admin/color-fans`, fanData);
  }

  deleteFan(Id: any): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`v1/admin/color-fans/${Id}`);
  }

  updateColorFan(Id: any, fanData: IColorFan): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`v1/admin/color-fans/${Id}`, fanData);
  }

  getFanByID(Id: any): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`v1/admin/color-fans/${Id}`);
  }

  downloadFile(path: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`/${path}`);
  }

  uploadFile(data: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`v1/file/upload/public`, data);
  }
  changeSequence(data: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/color-fans/updateSequence`, { data });
  }
  exportList(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>('/v1/admin/color-fans/export', {}, { ...options, params });
  }
}
